import React, { FC } from 'react'
import {
  IconButton,
  Skeleton,
  Stack,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'

import {
  DataTable,
  type DataTableColumn,
  EmptyState,
} from '@/apps/latest/components/portal/notion'
import { PORTAL_TEXT } from '@/apps/latest/shared/styles/portalTypography'
import {
  describeTracingRule,
  type TracingReportRule,
} from '@/features/internal/tracing-report'

interface Props {
  rules: TracingReportRule[] | undefined
  loading: boolean
  onDelete: (rule: TracingReportRule) => void
}

const COLUMNS: DataTableColumn[] = [
  { key: 'rule', label: 'ルール' },
  { key: 'actions', label: '', align: 'right' },
]

// トレーシングレポート提出ルールの一覧。自然文 1 文が主役。
// ルールは「医薬品グループ」だけを持つミニマム構成のため、編集は無し (削除して作り直す)。
export const TracingReportRuleTable: FC<Props> = ({
  rules,
  loading,
  onDelete,
}) => {
  if (loading) {
    return (
      <Stack gap={1}>
        {[1, 2].map((i) => (
          <Skeleton key={i} variant="rectangular" height={48} />
        ))}
      </Stack>
    )
  }

  if (!rules || rules.length === 0) {
    return (
      <EmptyState
        title="まだルールが作成されていません"
        hint="「新規ルール」から対象の医薬品グループを選んで作成してください"
      />
    )
  }

  return (
    <DataTable columns={COLUMNS}>
      {rules.map((rule) => (
        <TableRow key={rule.id} hover>
          <TableCell>
            <Typography sx={PORTAL_TEXT.cellBody}>
              {describeTracingRule(rule)}
            </Typography>
          </TableCell>
          <TableCell align="right" sx={{ width: 96 }}>
            <Tooltip title="削除" arrow>
              <IconButton size="small" onClick={() => onDelete(rule)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      ))}
    </DataTable>
  )
}
